import React from 'react';

const ContactSection = () => {
  return (
    <section id="contact">
      <div className="container">
        <div className="section-label">05 — Contact</div>
        <h2>
          Let&apos;s work<br />
          <em>together.</em>
        </h2>
        <p>
          Fancy a chat? Don&apos;t hesitate to reach out.
        </p>
        <div className="contact-links">
          <a href="mailto:bill.bolte@gmail.com" className="contact-link">✉ Email</a>
          <a href="https://www.linkedin.com/in/billbolte/" className="contact-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="/files/Bill-Bolte-Resume.pdf" className="contact-link" target="_blank" rel="noopener noreferrer">Resume</a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;

